/**
 * Computes carousel scroller metadata for CarouselScroller.
 * @param {number} totalItems
 * @param {number} slidesToShow
 * @param {number} [slidesToScroll=1]
 * @returns {{ totalSlides: number, showScroller: boolean }}
 */
export function getCarouselScrollerMeta(totalItems, slidesToShow, slidesToScroll = 1) {
  if (!totalItems || totalItems <= 0) {
    return { totalSlides: 1, showScroller: false };
  }

  const totalSlides = Math.max(1, Math.ceil((totalItems - slidesToShow) / slidesToScroll) + 1);

  return {
    totalSlides,
    showScroller: totalSlides > 1,
  };
}
